import { Truck, Zap } from "lucide-react";

export const SHIPPING_METHODS = {
  standard: { label: "Standard", carrier: "Canada Post Expedited Parcel™", Icon: Truck },
  express: { label: "Express", carrier: "Canada Post Xpresspost™", Icon: Zap },
};

export const shippingMethodLabel = (method) => SHIPPING_METHODS[method]?.label || "Standard";

export function ShippingMethodPicker({ value, onChange, cfg, standardDue, expressDue }) {
  const options = [
    { id: "standard", ...SHIPPING_METHODS.standard, eta: cfg.standardEta, fee: standardDue },
  ];
  if (cfg.expressEnabled) {
    options.push({ id: "express", ...SHIPPING_METHODS.express, eta: cfg.expressEta, fee: expressDue });
  }
  return (
    <div className="mb-8" data-testid="shipping-method-picker">
      <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#6E675F] mb-3">Delivery Speed</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {options.map(({ id, label, carrier, eta, fee, Icon }) => {
          const active = value === id;
          return (
            <button
              key={id}
              type="button"
              data-testid={`shipping-method-${id}`}
              aria-pressed={active}
              onClick={() => onChange(id)}
              className={`text-left border-2 rounded-lg p-4 transition-colors ${
                active ? "border-[#8C7B6B] bg-white" : "border-[#DDD7CF] bg-white/60 hover:border-[#8C7B6B]/50"
              }`}
            >
              <span className="flex items-center gap-2.5">
                <Icon className={`w-5 h-5 ${active ? "text-[#8C7B6B]" : "text-[#6E675F]"}`} />
                <span className="text-sm font-semibold text-[#1A1A1A]">{label}</span>
                <span className="ml-auto text-sm font-semibold" data-testid={`shipping-method-fee-${id}`}>
                  {fee > 0 ? <span className="text-[#1A1A1A]">${fee.toFixed(2)}</span> : <span className="text-[#2D6A4F]">FREE</span>}
                </span>
                <span className={`w-4 h-4 rounded-full border-2 ${active ? "border-[#8C7B6B] bg-[#8C7B6B]" : "border-[#DDD7CF]"}`} />
              </span>
              <span className="block text-xs text-[#6E675F] mt-1.5">{carrier} · {eta}</span>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-[#6E675F] mt-2" data-testid="shipping-method-note">
        {cfg.mode === "manual"
          ? "Both options are tracked by Canada Post."
          : `Both options are tracked. Free shipping over $${cfg.threshold} applies to Standard delivery.`}
      </p>
    </div>
  );
}
